import { Dispatch, SetStateAction } from 'react';

import { FAIconName } from '@equip.health/ui';

import ConfirmModal from '~/components/common/ConfirmModal';

type Props = {
  isDeleteNoteLoading: boolean;
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  onConfirm: () => void;
};
export const DeleteNoteModal = ({
  isDeleteNoteLoading,
  isOpen,
  onConfirm,
  setIsOpen,
}: Props) => {
  return (
    <ConfirmModal
      body="Are you sure you want to delete a draft note? This action cannot be undone."
      cancelIcon={FAIconName.XmarkRegular}
      cancelLabel="Cancel"
      confirmIcon={FAIconName.trashRegular}
      confirmLabel="Delete"
      confirmVariant="accent.critical"
      isLoading={isDeleteNoteLoading}
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      onConfirm={onConfirm}
      title="Delete note"
    />
  );
};
